import { Switch, Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import { postTrack } from "../../../services/trackService";
import useGetValidAccessToken from "../../../hooks/useGetValidAccessToken";
import { Dispatch, SetStateAction } from "react";
import { Track, TrackState } from "../../../proto/api_pb";

interface TrackPrivacySwitchProps {
  isTrackPublished: boolean;
  isTrackConnectedToTutorial: boolean;
  setIsPublishModalOpen: Dispatch<SetStateAction<boolean>>;
  track: Track | undefined;
  setIsTrackPublished: Dispatch<SetStateAction<boolean>>;
}

export const TrackPrivacySwitch: React.FC<TrackPrivacySwitchProps> = ({
  isTrackPublished,
  isTrackConnectedToTutorial,
  setIsPublishModalOpen,
  track,
  setIsTrackPublished,
}) => {
  const { getValidAccessToken } = useGetValidAccessToken();

  const updateTrackPrivacy = async () => {
    try {
      if (track) {
        setIsTrackPublished(false);
        track.setState(TrackState.TRACK_STATE_DRAFT);
        await postTrack(track, await getValidAccessToken());
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = () => {
    setIsPublishModalOpen(true);
  };
  return (
    <>
      <Tooltip title={isTrackPublished ? "Public" : "Private"}>
        <span style={{ fontSize: "12px", marginLeft: "15px" }}>
          {isTrackPublished ? "Public" : "Private"}
          <IconButton
            id={isTrackConnectedToTutorial ? "step-12" : ""}
            disableRipple
            onClickCapture={(e) => {
              e.stopPropagation();
              if (!isTrackPublished) {
                setIsPublishModalOpen(true);
              } else {
                updateTrackPrivacy();
              }
            }}
            sx={{ color: "white", zIndex: 1000 }}
          >
            <Switch
              checked={isTrackPublished}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
            />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
